import React from "react";
import { 
  BrowserRouter as Router, 
  Redirect, 
  Route, 
  Switch
} from "react-router-dom";
import MainNavigation from "./shared/components/navigation/MainNavigation";
import Appointments from "./appointment/pages/Appointments";
import Customers from "./customer/pages/Customers";
import NewCustomer from "./customer/pages/NewCustomer";
import UpdateCustomer from "./customer/pages/UpdateCustomer"
import Dashboard from "./dashboard/pages/Dashboard";
import Items from "./item/pages/Items";
import Orders from "./order/pages/Orders";
import NewOrder from "./order/pages/NewOrder";
import Auth from "./auth/pages/Auth";
import LoginForm from "./auth/pages/LoginForm";
import NewItem from "./item/pages/NewItem";
import UpdateItem from "./item/pages/UpdateItem";
import CustomerInfo from "./customer/pages/CustomerInfo";
import ItemInfo from "./item/pages/ItemInfo";
import OrderInfo from "./order/pages/OrderInfo";
import UpdateOrder from "./order/pages/UpdateOrder";
import SpecialOrders from "./specialOrder/pages/SpecialOrders";
import NewSpecialOrder from "./specialOrder/pages/NewSpecialOrder";
import SpecialOrderInfo from "./specialOrder/pages/SpecialOrderInfo";
import Alterations from "./alteration/pages/Alterations";
import UpdateSpecialOrder from "./specialOrder/pages/UpdateSpecialOrder";
import Print from "./print/page/Print"
import Consignments from "./consignment/pages/Consignments";
import NewConsignment from "./consignment/pages/NewConsignment";
import ConsignmentInfo from "./consignment/pages/ConsignmentInfo";
import UpdateConsignment from "./consignment/pages/UpdateConsignment";
import { useAuth } from './shared/hooks/auth-hook';
import { AuthContext } from './shared/context/auth-context';
import NewAlterations from "./alteration/pages/NewAlterations";
import AlterationInfo from "./alteration/pages/AlterationInfo";
import SendBacks from "./sendBacks/pages/SendBacks";
import SendBacksInfo from "./sendBacks/pages/SendBacksInfo";
import UpdateSendBack from "./sendBacks/pages/UpdateSendBack";
import UpdateAlteration from "./alteration/pages/UpdateAlteration";
import UpdateAppointments from "./appointment/pages/UpdateAppointments";
import SearchAppointments from "./appointment/pages/SearchAppointments";

const App = () => {

  const { token, login, logout, userId } = useAuth();

  let routes;
  
  if (token) {
    routes = (
        <Switch>
          <Route path="/" exact>           
            <Dashboard />
          </Route>
          <Route path="/consignments" exact>             
            <Consignments />
          </Route> 
          <Route path="/consignments/new" exact>            
            <NewConsignment />
          </Route>
          <Route path="/consignments/:consignmentId" exact>             
            <ConsignmentInfo />
          </Route>
          <Route path="/consignments/:consignmentId/edit" exact>            
            <UpdateConsignment />
          </Route>
          <Route path="/items" exact>          
            <Items />
          </Route> 
          <Route path="/items/new" exact>         
            <NewItem />
          </Route>
          <Route path="/items/:itemId" exact>          
            <ItemInfo />
          </Route>
          <Route path="/items/:itemId/edit" exact>          
            <UpdateItem />
          </Route>
          <Route path="/customers" exact>          
            <Customers />
          </Route>
          <Route path="/customers/new" exact>          
            <NewCustomer />
          </Route>
          <Route path="/customers/:customerId" exact>          
            <CustomerInfo />
          </Route>
          <Route path="/customers/:customerId/edit" exact>          
            <UpdateCustomer />
          </Route>
          <Route path="/orders" exact>            
            <Orders />
          </Route>
          <Route path="/orders/new" exact>          
            <NewOrder />
          </Route>
          <Route path="/orders/:orderId" exact>          
            <OrderInfo />
          </Route>
          <Route path="/orders/:orderId/edit" exact>          
            <UpdateOrder />
          </Route>
          <Route path="/appointments/:date" exact>          
            <Appointments />
          </Route>
          <Route path="/appointments/:date/update" exact>          
            <UpdateAppointments />
          </Route>
          <Route path="/appointments/search/:startDate/:endDate" exact>          
            <SearchAppointments/>
          </Route>
          <Route path="/specialOrders" exact>         
            <SpecialOrders />
          </Route>
          <Route path="/specialOrders/new" exact>          
            <NewSpecialOrder />
          </Route>
          <Route path="/specialOrders/:specialOrderId" exact>           
            <SpecialOrderInfo />
          </Route>
          <Route path="/specialOrders/:specialOrderId/edit" exact>           
            <UpdateSpecialOrder />
          </Route>
          <Route path="/print/:printObj" exact>
            <Print />
          </Route>
          <Route path="/alterations" exact>          
            <Alterations />
          </Route>
          <Route path="/alterations/new" exact>
            <NewAlterations />
          </Route>
          <Route path="/alterations/:alterationId" exact>
            <AlterationInfo />
          </Route>
          <Route path="/alterations/:alterationId/edit" exact>
            <UpdateAlteration />
          </Route>
          <Route path="/sendBacks" exact>          
            <SendBacks />
          </Route>
          <Route path="/sendBacks/:sendbacksId" exact>          
            <SendBacksInfo />
          </Route>
          <Route path="/sendBacks/:sendbacksId/edit" exact>          
            <UpdateSendBack />
          </Route>
          <Redirect to="/" />
        </Switch>
    );
  } else {
    routes = (
        <Switch>
          <Route path="/auth" exact>
            <Auth />
            {/* <LoginForm /> */}
          </Route>
          <Redirect to="/auth" />
        </Switch>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn: !!token,
        token: token,
        userId: userId,
        login: login,
        logout: logout
      }}
    >
    <>
      <Router>
        <MainNavigation />
        <main>{routes}</main>
      </Router>
      </>
    </AuthContext.Provider>
  );
};
export default App;
